import { __decorate } from "tslib";
import { Component, EventEmitter, Output } from '@angular/core';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedHttp } from '../../../../services/http-client.service';
let BlinkingNotAvailableComponent = class BlinkingNotAvailableComponent {
    constructor(themeService, sanitizer, httpClient) {
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.fillGeneralData = new EventEmitter();
        this.blinkingAvailable = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
    }
    ngOnInit() {
        this.interval = setInterval(() => {
            this.checkBlinkingAvailability();
        }, 10000);
    }
    checkBlinkingAvailability() {
        this.httpClient.get('blinking/checkAvailability').subscribe((data) => {
            this.blinkingAvailable.emit(true);
            if (this.interval) {
                clearInterval(this.interval);
            }
        });
    }
    goToGeneralPersonalDataComponent() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.fillGeneralData.emit(true);
    }
};
BlinkingNotAvailableComponent.ctorParameters = () => [
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: SharedHttp }
];
__decorate([
    Output()
], BlinkingNotAvailableComponent.prototype, "fillGeneralData", void 0);
__decorate([
    Output()
], BlinkingNotAvailableComponent.prototype, "blinkingAvailable", void 0);
BlinkingNotAvailableComponent = __decorate([
    Component({
        selector: 'ecd-blinking-not-available',
        template: __importDefault(require("./blinking-not-available.component.html")).default
    })
], BlinkingNotAvailableComponent);
export { BlinkingNotAvailableComponent };
